import type { FC } from 'react';
import { memo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { SubmitButtonV3, SubmitButtonV3Icon } from '../../components/FinalForm/SubmitButtonV3';
import { ReactComponent as IconSendOutlined } from '../../icons/send-email-2.svg';
// The new icon will be:
// import { ReactComponent as SendIcon } from '../../icons/send-email-2.svg';
import { BoostField } from './BoostField';
import { DisplayWhenValid } from './DisplayWhenValid';

export const messages = defineMessages({
  sendLabel: {
    defaultMessage: 'Envoyer',
    id: 'EWLVLG',
  },
});

interface EditorSubmitButtonProps {
  loading: boolean | undefined;
  hasInitialValue: boolean;
  isAdmin: boolean;
}

export const EditorSubmitButton: FC<EditorSubmitButtonProps> = memo(function EditorSubmitButton(
  props,
) {
  const { loading, hasInitialValue, isAdmin } = props;

  return (
    <DisplayWhenValid hasInitialValue={hasInitialValue} loading={loading}>
      {isAdmin ? <BoostField name="adminBoost" /> : null}
      <SubmitButtonV3Icon
        className="h-10 w-10 rounded-md bg-primary md:hidden"
        icon={<IconSendOutlined className="h-5 w-5 text-white" />}
        loading={loading}
      />
      <SubmitButtonV3 className="_md:hidden">
        <FormattedMessage {...messages.sendLabel} />
      </SubmitButtonV3>
    </DisplayWhenValid>
  );
});
